import '../style/list-CIvFUzMr.css'
import { ref as B, watch as U, computed as s, onMounted as ce, defineComponent as se, openBlock as u, createElementBlock as v, Fragment as R, renderList as D, normalizeClass as O, normalizeStyle as G, createBlock as E, unref as e, mergeProps as W, createVNode as K, toRefs as pe, withDirectives as ve, renderSlot as P, createCommentVNode as x, withCtx as A, createElementVNode as Q, createTextVNode as fe, toDisplayString as he, isRef as ye, createSlots as ge, normalizeProps as be, guardReactiveProps as Se } from "vue";
import ke from "./link.js";
import we from "./popper.js";
import { DEFAULT_LIST_ITEM_HEIGHT as Ce, DEFAULT_LIST_POPPER as _e } from "./constant/list.js";
import $e from "./directives/ripple.js";
import { useListSkeleton as He } from "./hooks/useListSkeleton.js";
import { useMobileView as Te } from "./hooks/useMobileView.js";
import Ie from "./internalComponents/Empty.js";
import Le from "./internalComponents/SortIcon.js";
import Pe from "./internalComponents/defaultHeaderSlot.js";
import Be from "./internalComponents/MobileDetail.js";
import { setListCSSVariables as te, getListItemClass as Re } from "./utils/list.js";
import { unrefElement as Ee, useScroll as Me } from "@vueuse/core";
import { useEventDelegation as ze } from "./hooks/useEventDelegation.js";
import Ve from "./spinner.js";
import oe, { SkeletonGrid as Ge } from "./skeleton.js";
import { pxlize as De } from "x-utils";
import { useBorderBoxElementSize as le } from "./hooks/useBorderBoxElementSize.js";
import { useSort as Ne } from "./hooks/useSort.js";
import { useScrollerClassList as Oe } from "./hooks/useScroller.js";
import { getColumnClassStyle as Fe, ListComponentTypeEnum as je } from "./utils/listColumn.js";
import { useVisibleSize as xe } from "./hooks/useVisibleSize.js";
function Ae(m) {
  const { body: n, isMobile: o, rows: r, virtualTop: t, emit: l } = m, y = B(!1), S = B(), g = B(-1);
  U(r, () => {
    y.value && g.value !== -1 && (S.value = r.value[g.value]);
  });
  const w = B(-1), C = B(0), c = s(() => w.value >= 0 ? {
    top: Math.max(C.value, 0) + "px",
    zIndex: 100,
    "--popper-theme-background": "var(--bg-surface-emphasis)"
  } : {});
  return ze({
    element: n,
    eventListeners: [
      {
        eventName: "mouseover",
        selector: ".e-list-item",
        handler: (d) => {
          const p = d.dataset.rowIndex, f = Number(d.dataset.realIndex);
          if (p) {
            const k = +p, I = r.value[k], _ = Ee(n);
            _ && (C.value = d.offsetTop - _.scrollTop + t.value), w.value = k, l("row-hover", I, f);
          }
        }
      },
      {
        eventName: "mouseleave",
        handler: () => {
          w.value = -1, l("row-hover", null, -1);
        }
      },
      {
        eventName: "click",
        selector: ".e-list-item",
        handler: (d) => {
          const p = d.dataset.rowIndex;
          if (p) {
            const f = +p, k = r.value[f];
            o.value && (y.value = !0), S.value = k, g.value = f, l("row-click", k, f);
          }
        }
      }
    ]
  }), {
    isShowDetail: y,
    detailRow: S,
    hoverIndex: w,
    popperStyle: c
  };
}
function Ke(m, n, o) {
  return {
    computedColumns: s(() => {
      const t = m.value;
      return t.map((l, y) => {
        const { headerClass: S, bodyClass: g, headerStyle: w, bodyStyle: C } = Fe(l, je.List), c = {
          role: "columnheader",
          tabindex: "0"
        };
        return l.sortable && (l.sortProp = l.sortProp || l.prop), l.sortProp && l.sortProp === n.value && S.push("e-column-header--highlight"), o.length && (c.onClick = () => {
          o.forEach((d) => {
            d(l);
          });
        }), y === 0 && g.push("e-list-cell--first"), y === t.length - 1 && g.push("e-list-cell--last"), {
          ...l,
          attributes: c,
          _headerClass: S,
          _bodyClass: g,
          _headerStyle: w,
          _bodyStyle: C
        };
      });
    })
  };
}
function Ue(m, n) {
  let o = n ?? "";
  const r = m.map((t) => t.width);
  return r.some((t) => !!t) && (o = r.reduce((t, l) => {
    const y = l ? De(l) : "1fr";
    return t += y + " ", t;
  }, "")), o;
}
function We(m, n, o) {
  const { height: r } = le(m), { height: t } = le(n, { width: 0, height: o.headerHeight ?? 0 }), l = s(() => Math.max(r.value - t.value, 0));
  return {
    headerHeight: t,
    bodyHeight: l,
    wrapperHeight: r
  };
}
function Ye(m) {
  const { classList: n } = Oe(m.scroller), o = s(() => {
    const t = [
      "e-list",
      {
        "e-list--bordered": m.isBordered,
        "e-list--loading": m.loading
      }
    ];
    return m.theme && t.push(`e-theme--${m.theme}`), t;
  }), r = s(() => [
    "e-list-body",
    {
      "e-list-body--loading": m.loading && !m.skeleton
    },
    ...n.value
  ]);
  return {
    wrapperClass: o,
    bodyClass: r
  };
}
function qe(m, n, o, r) {
  const { fixedHeader: t, virtualScroll: l, presort: y } = o, { sortProp: S, sortDirection: g, sortHandler: w, sortedRows: C } = Ne(r, y), { bodyHeight: c } = We(m, n, o), d = s(() => !!l), p = s(() => d.value || !!t), f = s(() => {
    if (!o.autoFixItemHeight)
      return o.itemHeight || 0;
    const b = Math.floor(c.value / (o.itemHeight || 0));
    return c.value / b - (o.rowGap || 0);
  }), k = s(() => {
    const b = {
      rowGap: o.rowGap,
      headerHeight: o.headerHeight,
      itemHeight: f.value,
      gridTemplateColumns: Ue(o.columns ?? [], o.gridTemplateColumns)
    };
    return p.value && (b.bodyHeight = c.value), b;
  });
  U(k, (b) => {
    te(m.value, b);
  }, { deep: !0 });
  const { wrapperClass: I, bodyClass: _ } = Ye(o), H = s(() => {
    const b = {};
    return p.value && (b.height = c.value + "px"), b;
  });
  return ce(() => {
    te(m.value, k.value);
  }), {
    bodyHeight: c,
    realItemHeight: f,
    wrapperClass: I,
    bodyClass: _,
    bodyStyle: H,
    scrollable: p,
    isVirtual: d,
    sortProp: S,
    sortDirection: g,
    columnHandlers: [w],
    rows: C
  };
}
function Je(m) {
  const {
    element: n,
    rows: o,
    bodyHeight: r,
    virtualScroll: t,
    realItemHeight: l,
    rowGap: y
  } = m, { isScrolling: S, arrivedState: g, y: w } = Me(n), C = s(() => g.bottom), c = s(() => o.value.length), d = s(() => l.value + y), p = s(() => c.value * d.value - (o.value.length > 0 ? y : 0)), f = xe(r, d), k = s(() => o.value.map((h, T) => ({
    ...h,
    _realIndex: T
  }))), I = (h) => {
    n.value?.scrollTo({ top: h });
  };
  if (!t)
    return {
      isScrolling: S,
      isBottomArrived: C,
      renderRows: k,
      itemsContainerStyle: {},
      itemsStyle: {},
      virtualTop: s(() => 0),
      visibleSize: f,
      scrollTo: I
    };
  const _ = s(() => typeof t == "boolean" ? 1 : t.renderedPages ?? 1), H = s(() => Math.min(f.ceilSize * _.value, c.value)), b = s(() => Math.max(p.value - d.value * H.value, 0)), z = s(() => {
    const h = Math.floor(w.value / d.value), T = _.value > 1 ? H.value / (_.value + 1) : 0;
    let N = Math.max(Math.floor(h - T), 0);
    return N + H.value > c.value && (N = c.value - H.value), N;
  }), Y = s(() => z.value + H.value), V = s(() => {
    let h = z.value * d.value, T = b.value - h;
    return z.value > 0 && T < d.value && (T = 0, h = b.value), { top: h, bottom: T };
  }), F = s(() => k.value.slice(z.value, Y.value)), q = s(() => ({
    height: p.value + "px"
  })), L = s(() => ({
    transform: `translateY(${V.value.top}px)`
  }));
  return {
    isScrolling: S,
    isBottomArrived: C,
    renderRows: F,
    itemsContainerStyle: q,
    itemsStyle: L,
    virtualTop: s(() => V.value.top),
    visibleSize: f,
    scrollTo: I
  };
}
const Qe = {
  key: 0,
  class: "e-list-items",
  "aria-busy": "true"
}, Xe = {
  key: 1,
  class: "e-list-loading",
  "aria-busy": "true"
}, re = /* @__PURE__ */ se({
  __name: "loading",
  props: {
    computedColumns: {},
    skeleton: {}
  },
  setup(m) {
    return (n, o) => n.skeleton ? (u(), v("div", Qe, [
      (u(!0), v(R, null, D(n.skeleton.numberOfRows, (r) => (u(), v("div", {
        key: r,
        class: "e-list-item"
      }, [
        (u(!0), v(R, null, D(n.computedColumns, (t, l) => (u(), v("div", {
          key: t.prop,
          class: O(t._bodyClass),
          style: G(t._bodyStyle)
        }, [
          n.skeleton?.columns?.[l] ? (u(), v(R, { key: 0 }, [
            n.skeleton?.columns?.[l].type === "grid" ? (u(), E(e(Ge), W({
              key: 0,
              ref_for: !0
            }, n.skeleton?.columns?.[l].props), null, 16)) : (u(), E(e(oe), W({
              key: 1,
              ref_for: !0
            }, n.skeleton?.columns?.[l].props), null, 16))
          ], 64)) : (u(), E(e(oe), { key: 1 }))
        ], 6))), 128))
      ]))), 128))
    ])) : (u(), v("div", Xe, [
      K(e(Ve), {
        size: 30,
        "stroke-width": "3"
      })
    ]));
  }
}), Ze = ["aria-sort"], et = /* @__PURE__ */ Q("div", { class: "e-list-popper__trigger" }, null, -1), Ct = /* @__PURE__ */ se({
  name: "e-list",
  __name: "list",
  props: {
    isBordered: { type: Boolean, default: !0 },
    loading: { type: Boolean },
    skeleton: { type: [Object, Boolean] },
    showHeader: { type: Boolean, default: !0 },
    fixedHeader: { type: Boolean },
    columns: { default: () => [] },
    gridTemplateColumns: {},
    headerHeight: {},
    itemHeight: { default: Ce },
    autoFixItemHeight: { type: Boolean },
    source: { default: () => [] },
    presort: { default: () => ({
      sortProp: null,
      sortDirection: null
    }) },
    dataKey: {},
    rowGap: { default: 0 },
    rowKey: {},
    virtualScroll: { type: [Object, null, Boolean] },
    theme: {},
    rowRipple: { type: [Boolean, Object] },
    headerRipple: { type: [Boolean, Object] },
    popper: {},
    scroller: {},
    infiniteScroll: { type: Boolean },
    overrides: {}
  },
  emits: ["row-click", "row-hover", "sorted", "virtual", "scroll-to-bottom"],
  setup(m, { expose: n, emit: o }) {
    const r = m, t = o, { source: l, columns: y, skeleton: S, loading: g, itemHeight: w } = pe(r), C = B(), c = B(), d = B(), p = s(() => r.popper ? { ..._e, ...r.popper } : null), { isMobile: f } = Te(), {
      wrapperClass: k,
      bodyClass: I,
      bodyStyle: _,
      bodyHeight: H,
      realItemHeight: b,
      scrollable: z,
      columnHandlers: Y,
      sortProp: V,
      sortDirection: F,
      rows: q
    } = qe(C, c, r, l), { computedColumns: L } = Ke(y, V, Y), {
      renderRows: h,
      itemsStyle: T,
      itemsContainerStyle: N,
      virtualTop: ne,
      isScrolling: ie,
      isBottomArrived: ae,
      visibleSize: X,
      scrollTo: ue
    } = Je({
      element: d,
      rows: q,
      bodyHeight: H,
      realItemHeight: b,
      rowGap: r.rowGap,
      virtualScroll: r.virtualScroll
    }), Z = He({ skeleton: S, columns: L, scrollable: z, visibleSize: X, itemHeight: w });
    U(ae, (i) => {
      i && t("scroll-to-bottom");
    }), U(X, (i) => {
      r.virtualScroll && t("virtual", i);
    });
    const { isShowDetail: J, detailRow: me, hoverIndex: j, popperStyle: de } = Ae({
      body: d,
      isMobile: f,
      rows: h,
      virtualTop: ne,
      emit: t
    });
    return n({
      scrollTo: ue
    }), (i, ee) => (u(), v("div", {
      ref_key: "wrapper",
      ref: C,
      class: O(e(k)),
      style: G(i.overrides),
      role: "grid",
      tabindex: "0"
    }, [
      i.showHeader ? (u(), v("div", {
        key: 0,
        ref_key: "header",
        ref: c,
        class: "e-list-header",
        role: "row"
      }, [
        (u(!0), v(R, null, D(e(L), (a) => ve((u(), v("div", W({
          key: a.prop,
          "aria-sort": e(V) === a.sortProp ? e(F) ?? "none" : "none",
          class: a._headerClass,
          style: a._headerStyle,
          ref_for: !0
        }, a.attributes), [
          P(i.$slots, `header-${a.prop}`, { col: a }, () => [
            K(Pe, {
              title: a.title,
              tooltip: a.tooltip
            }, null, 8, ["title", "tooltip"])
          ]),
          K(Le, {
            column: a,
            "sort-prop": e(V),
            "sort-direction": e(F)
          }, null, 8, ["column", "sort-prop", "sort-direction"])
        ], 16, Ze)), [
          [e($e), i.headerRipple]
        ])), 128))
      ], 512)) : x("", !0),
      p.value && !p.value.disabled && e(j) >= 0 ? (u(), E(e(we), W({ key: 1 }, p.value, {
        show: !0,
        style: e(de),
        teleported: !1
      }), {
        content: A(() => [
          P(i.$slots, "$popper", {
            row: e(h)[e(j)],
            index: e(j)
          })
        ]),
        default: A(() => [
          et
        ]),
        _: 3
      }, 16, ["style"])) : x("", !0),
      Q("div", {
        ref_key: "body",
        ref: d,
        class: O(e(I)),
        style: G(e(_))
      }, [
        e(g) && !(i.virtualScroll && i.infiniteScroll && e(h).length) ? (u(), E(re, {
          key: 0,
          skeleton: e(Z),
          "computed-columns": e(L)
        }, null, 8, ["skeleton", "computed-columns"])) : e(h).length ? (u(), v("div", {
          key: 2,
          class: "e-list-items-container",
          style: G(e(N))
        }, [
          Q("div", {
            class: "e-list-items",
            style: G(e(T))
          }, [
            (u(!0), v(R, null, D(e(h), (a, $) => (u(), v(R, {
              key: i.rowKey ? a[i.rowKey] : $
            }, [
              a.$options?.customProp ? P(i.$slots, `$custom-${a.$options?.customProp}`, {
                key: 0,
                row: a,
                index: $
              }) : (u(), E(e(ke), {
                key: 1,
                class: O(e(Re)(a, e(j), $, p.value)),
                ripple: i.rowRipple,
                to: a.$to,
                role: "row",
                tabindex: "0",
                "data-row-index": $,
                "data-real-index": a._realIndex
              }, {
                default: A(() => [
                  i.$slots.$custom ? P(i.$slots, "$custom", {
                    key: 0,
                    index: $,
                    row: a,
                    isScrolling: e(ie),
                    isMobile: e(f)
                  }) : (u(), v(R, { key: 1 }, [
                    (u(!0), v(R, null, D(e(L), (M) => (u(), v("div", {
                      key: M.prop,
                      class: O(M._bodyClass),
                      style: G(M._bodyStyle),
                      role: "cell"
                    }, [
                      P(i.$slots, M.prop, {
                        row: a,
                        index: $
                      }, () => [
                        fe(he(a[M.prop]), 1)
                      ])
                    ], 6))), 128)),
                    P(i.$slots, "$row", {
                      row: a,
                      index: $
                    })
                  ], 64))
                ]),
                _: 2
              }, 1032, ["class", "ripple", "to", "data-row-index", "data-real-index"]))
            ], 64))), 128)),
            e(g) && i.virtualScroll && i.infiniteScroll && e(h).length ? (u(), E(re, {
              key: 0,
              skeleton: e(Z),
              "computed-columns": e(L)
            }, null, 8, ["skeleton", "computed-columns"])) : x("", !0)
          ], 4)
        ], 4)) : P(i.$slots, "empty", { key: 1 }, () => [
          K(Ie, {
            variant: "list",
            "is-small": e(f)
          }, null, 8, ["is-small"])
        ])
      ], 6),
      i.$slots.$detail ? (u(), E(Be, {
        key: 2,
        modelValue: e(J),
        "onUpdate:modelValue": ee[0] || (ee[0] = (a) => ye(J) ? J.value = a : null),
        row: e(me),
        columns: e(L)
      }, ge({ _: 2 }, [
        D(i.$slots, (a, $) => ({
          name: $,
          fn: A((M) => [
            P(i.$slots, $, be(Se(M)))
          ])
        }))
      ]), 1032, ["modelValue", "row", "columns"])) : x("", !0)
    ], 6));
  }
});
export {
  Ct as default
};
//# sourceMappingURL=list.js.map
